import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { LoaderService } from 'src/app/loader.service';
import { AlertDialogService } from 'src/app/shared/alert-dialog/alert-dialog.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { ToasterService } from 'src/app/toaster.service';
import { SubscriptionService } from '../../subscription.service';
import { planTypeFromConfig } from '../../subscription.applicable-types';
import { subscriptionAccessFeeCreateAlert, subscriptionOperationFailureAlert } from '../../subscription.create-alert';
var CreateAccessFeeComponent = /** @class */ (function () {
    function CreateAccessFeeComponent(sharedService, subsService, loader, alertService, toasterService) {
        this.sharedService = sharedService;
        this.subsService = subsService;
        this.loader = loader;
        this.alertService = alertService;
        this.toasterService = toasterService;
        this.accessFeeFormGroup = new FormGroup({
            planName: new FormControl(null),
            city: new FormControl(null),
            services: new FormControl(null),
            zones: new FormControl(null),
            userSelector: new FormControl(null),
            targetSegment: new FormControl('userSelectors'),
            priority: new FormControl(null),
            startDate: new FormControl(null),
            endDate: new FormControl(null),
            tiers: new FormControl([])
        });
        this.context = null;
        this.launch = null;
        this.launchServiceUnavailable = new EventEmitter();
        this.launchConsumed = new EventEmitter();
        this.cities = [];
        this.zones = [];
        this.services = [];
        this.userSelectors = [];
        this.deductionCondition = 'Days';
        this.daysCondition = '1';
        this.today = moment().startOf('day').toDate();
        this.tomorrowEod = moment().endOf('day').add(1, 'days').toDate();
        this.minEndDate = this.tomorrowEod;
        this.compareServices = function (a, b) { return a && b && String(a.id) === String(b.id); };
        this.initializeCities();
        this.addTier();
    }
    CreateAccessFeeComponent.prototype.initializeCities = function () {
        var _this = this;
        this.loader.openLoading();
        this.initReady = this.fetchCities().finally(function () { return _this.loader.closeLoading(); });
    };
    CreateAccessFeeComponent.prototype.applyLaunchQueryPrefill = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var q, cityId, serviceId, city, matched, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        q = this.launch || { city: '', service: '' };
                        cityId = (q.city || '').trim();
                        serviceId = (q.service || '').trim();
                        if (!cityId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.initReady];
                    case 2:
                        _a.sent();
                        city = this.cities.find(function (c) { return String(c.id) === String(cityId); });
                        if (!city) {
                            this.errorMessage('City from launch URL is not available.');
                            this.launchConsumed.emit();
                            return [2 /*return*/];
                        }
                        this.accessFeeFormGroup.get('city').setValue(city, { emitEvent: false });
                        return [4 /*yield*/, this.fetchServices()];
                    case 3:
                        _a.sent();
                        if (!serviceId) {
                            this.launchConsumed.emit();
                            return [2 /*return*/];
                        }
                        matched = (this.services || []).filter(function (s) { return String(s.id) === String(serviceId); });
                        if (!matched.length) {
                            this.launchServiceUnavailable.emit();
                            return [2 /*return*/];
                        }
                        this.accessFeeFormGroup.get('services').setValue(matched);
                        this.launchConsumed.emit();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error('Launch prefill failed', err_1);
                        this.launchConsumed.emit();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CreateAccessFeeComponent.prototype.resetOnchangeOf = function (controlName, toReset, cb) {
        var _this = this;
        if (cb === void 0) { cb = function () { }; }
        this.accessFeeFormGroup.get(controlName).valueChanges.subscribe(function () {
            toReset.forEach(function (control) {
                _this.accessFeeFormGroup.get(control).setValue(null);
            });
            cb();
        });
    };
    CreateAccessFeeComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetOnchangeOf("city", ["services", "zones", "userSelector", "tiers", "startDate", "endDate", "priority"], function () {
                            _this.services = [];
                            _this.userSelectors = [];
                            try {
                                _this.addTier();
                                _this.fetchServices();
                            }
                            catch (err) {
                                console.error(err);
                            }
                        });
                        this.resetOnchangeOf("services", ["zones", "userSelector", "tiers", "startDate", "endDate", "priority"], function () {
                            _this.userSelectors = [];
                            _this.zones = [];
                            try {
                                _this.addTier();
                                _this.fetchZones();
                                _this.fetchSelectors();
                                _this.validateModeAndGeoGroupIdForServices();
                            }
                            catch (err) {
                                console.error(err);
                            }
                        });
                        this.resetOnchangeOf("zones", ["userSelector", "tiers", "startDate", "endDate", "priority"], function () {
                            _this.addTier();
                        });
                        this.accessFeeFormGroup.get('targetSegment').valueChanges.subscribe(function () {
                            _this.applyTargetSegmentFields();
                        });
                        this.applyTargetSegmentFields();
                        if (!this.context) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.applyParentContext()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.applyLaunchQueryPrefill()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CreateAccessFeeComponent.prototype.applyTargetSegmentFields = function () {
        var _this = this;
        var isUserSelector = this.formValue('targetSegment') === 'userSelectors';
        ['endDate', 'priority', 'userSelector'].forEach(function (name) {
            var control = _this.accessFeeFormGroup.get(name);
            if (isUserSelector) {
                control.enable({ emitEvent: false });
                return;
            }
            control.setValue(null, { emitEvent: false });
            control.disable({ emitEvent: false });
        });
    };
    CreateAccessFeeComponent.prototype.blockInvalidNumberKeys = function (event) {
        if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
            event.preventDefault();
        }
    };
    CreateAccessFeeComponent.prototype.rejectNegativeAmount = function (event, control) {
        var input = event.target;
        if (input.value === '' || input.value == null) {
            return;
        }
        if (Number(input.value) < 0) {
            control.setValue(null);
            input.value = '';
        }
    };
    CreateAccessFeeComponent.prototype.applyParentContext = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parentService, matched, injected;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initReady];
                    case 1:
                        _a.sent();
                        this.accessFeeFormGroup.get('city').setValue(this.context.city, { emitEvent: false });
                        return [4 /*yield*/, this.fetchServices()];
                    case 2:
                        _a.sent();
                        parentService = this.context.service;
                        if (!parentService) {
                            return [2 /*return*/];
                        }
                        matched = (this.services || []).filter(function (s) { return String(s.id) === String(parentService.id); });
                        if (!matched.length) {
                            injected = {
                                id: parentService.id,
                                name: parentService.name,
                                mode: (this.context.mode && this.context.mode.id) || parentService.mode,
                                serviceDetailId: parentService.serviceDetailId,
                                geoServiceGroupId: parentService.geoServiceGroupId || '',
                                categoryId: this.context.category && this.context.category.id
                            };
                            this.services = [injected].concat(this.services || []);
                            matched = [injected];
                        }
                        this.accessFeeFormGroup.get('services').setValue(matched, { emitEvent: false });
                        this.fetchZones();
                        this.fetchSelectors();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateAccessFeeComponent.prototype.fetchSelectors = function () {
        var _this = this;
        var city = this.formValue("city");
        var services = this.formValue("services");
        if (city && services) {
            var serviceTypes = services
                .map(function (s) { return s.serviceDetailId; }).join(",");
            this.loader.openLoading();
            this.sharedService
                .fetchRules(city.id, serviceTypes, null, "rider", "custom")
                .toPromise()
                .then(function (res) {
                _this.userSelectors = res.data.selectors
                    .map(function (_a) {
                    var _id = _a._id, name = _a.name;
                    return ({ id: _id, name: name });
                });
            })
                .finally(function () { return _this.loader.closeLoading(); });
        }
    };
    CreateAccessFeeComponent.prototype.formValue = function (name) {
        return this.accessFeeFormGroup.get(name).value;
    };
    CreateAccessFeeComponent.prototype.fetchZones = function () {
        var _this = this;
        var city = this.formValue("city");
        var services = this.formValue("services") || [];
        var geoGroupIds = {};
        services.forEach(function (service) {
            if (service.geoServiceGroupId) {
                geoGroupIds[service.geoServiceGroupId] = true;
            }
        });
        var groupIds = Object.keys(geoGroupIds);
        if (!city || !groupIds.length) {
            this.zones = [];
            return Promise.resolve();
        }
        this.loader.openLoading();
        return Promise.all(groupIds.map(function (groupId) {
            return _this.sharedService.fetchZones(city.id, groupId).toPromise();
        }))
            .then(function (responses) {
            var seen = {};
            _this.zones = [];
            responses.forEach(function (res) {
                ((res && res.geolayers) || []).forEach(function (_a) {
                    var id = _a.id, name = _a.name;
                    if (seen[id]) {
                        return;
                    }
                    seen[id] = true;
                    _this.zones.push({ id: id, name: name });
                });
            });
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateAccessFeeComponent.prototype.fetchServices = function () {
        var _this = this;
        var city = this.formValue("city");
        if (!city) {
            return Promise.resolve();
        }
        this.loader.openLoading();
        return this.sharedService
            .fetchServicesWithMode(city.id)
            .toPromise()
            .then(function (res) {
            var parentCategoryId = _this.context && _this.context.category && _this.context.category.id;
            var mapped = res.data
                .filter(function (serviceDetail) { return serviceDetail.active; })
                .filter(function (_a) {
                var modeInfo = _a.modeInfo;
                return !_this.context || !_this.context.mode
                    || String(modeInfo._id) === String(_this.context.mode.id);
            })
                .map(function (_a) {
                var service = _a.service, _id = _a._id, modeInfo = _a.modeInfo, category = _a.category, serviceCategory = _a.serviceCategory, categoryName = _a.categoryName;
                var rawCategory = (category && (category._id || category.id || category.name))
                    || (serviceCategory && (serviceCategory._id || serviceCategory.id || serviceCategory.name))
                    || (service && service.category && (service.category._id || service.category.id || service.category.name))
                    || (service && service.categoryName)
                    || categoryName;
                return {
                    id: service._id,
                    name: service.name,
                    mode: modeInfo._id,
                    serviceDetailId: _id,
                    geoServiceGroupId: service.geoServiceGroupId,
                    categoryId: rawCategory ? String(rawCategory) : parentCategoryId
                };
            });
            var sdids = mapped.map(function (item) { return item.serviceDetailId; }).filter(Boolean);
            if (!sdids.length) {
                _this.services = [];
                return;
            }
            var modeId = (_this.context && _this.context.mode && _this.context.mode.id) || (mapped[0] && mapped[0].mode);
            return _this.subsService.getApplicableTypes(sdids, modeId).toPromise().then(function (configsRes) {
                var configs = (configsRes && configsRes.data) || {};
                _this.services = mapped.filter(function (item) { return planTypeFromConfig(configs[item.serviceDetailId]) === 'accessFee'; });
            });
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateAccessFeeComponent.prototype.fetchCities = function () {
        var _this = this;
        return this.sharedService
            .fetchCities()
            .toPromise()
            .then(function (res) {
            _this.cities = res.data.cities
                .map(function (_a) {
                var _id = _a._id, displayName = _a.displayName;
                return ({ id: _id, name: displayName });
            });
        });
    };
    CreateAccessFeeComponent.prototype.changeInDate = function () {
        var startDate = this.formValue("startDate");
        if (startDate) {
            this.minEndDate = startDate;
        }
        var endDate = this.formValue("endDate");
        if (endDate) {
            this.maxStartDate = endDate;
        }
        else {
            this.maxStartDate = null;
        }
    };
    CreateAccessFeeComponent.prototype.createAccessFeeRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var plans, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.buildBillingPlan()];
                    case 2:
                        plans = _a.sent();
                        if (!plans) {
                            return [2 /*return*/];
                        }
                        this.subsService.createBillingPlan({ plans: plans }).subscribe(function (resp) {
                            _this.alertService.open(subscriptionAccessFeeCreateAlert(resp));
                        }, function (error) {
                            _this.alertService.open(subscriptionOperationFailureAlert(error));
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.alertService.open(subscriptionOperationFailureAlert(error_1));
                        return [3 /*break*/, 5];
                    case 4:
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CreateAccessFeeComponent.prototype.alertMessage = function (alert) {
        this.alertService.open(alert);
    };
    CreateAccessFeeComponent.prototype.errorMessage = function (message) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: message
        }));
    };
    CreateAccessFeeComponent.prototype.validateField = function (fieldName, message) {
        var value = this.formValue(fieldName);
        if (!value) {
            this.errorMessage(message);
            throw new Error(message);
        }
        return value;
    };
    CreateAccessFeeComponent.prototype.buildBillingPlan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var planName, city, services, mode, zones, startDate, endDate, priority, userSelector, minRides, i, commonFields;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                planName = this.validateField("planName", "Plan name is required");
                city = this.validateField("city", "City is required");
                services = this.validateField("services", "Services is required");
                mode = this.validateModeAndGeoGroupIdForServices();
                zones = this.formValue("zones");
                startDate = this.validateField("startDate", "Purchase Start date is required");
                endDate = this.formValue("endDate");
                if (this.accessFeeFormGroup.get('targetSegment').value === 'userSelectors') {
                    priority = this.formValue("priority");
                    if (!priority || !Number.isInteger(priority) || priority <= 0) {
                        this.errorMessage("Priority is required/should be positive number for userSelector");
                        throw new Error("Priority is required/should be positive number for userSelector");
                    }
                    userSelector = this.formValue("userSelector");
                    if (!userSelector) {
                        this.errorMessage("UserSelector is required for targetSegment userSelector");
                        throw new Error("UserSelector is required for targetSegment userSelector");
                    }
                }
                else {
                    if (this.formValue("endDate")) {
                        this.errorMessage("End date cannot be set for plans without user selectors");
                        throw new Error("End date cannot be set for plans without user selectors");
                    }
                }
                if (this.formValue('tiers').length < 1) {
                    this.errorMessage("At least one tier is required");
                }
                if (this.formValue('tiers').length > 1) {
                    minRides = this.formValue('tiers').map(function (tier) { return tier.minRides.value; });
                    for (i = 1; i < minRides.length; i++) {
                        if (minRides[i] <= minRides[i - 1]) {
                            this.errorMessage("Minimum rides should be in increasing order");
                            throw new Error("Minimum rides should be in increasing order");
                        }
                    }
                }
                commonFields = {
                    planName: planName,
                    startDate: moment(startDate).format("YYYY-MM-DD"),
                    priority: Number(priority),
                    city: city.id,
                    services: services.map(function (s) { return s.id; }),
                    zones: zones && zones.length > 0 ? zones.map(function (z) { return z.id; }) : undefined,
                    mode: mode,
                    userSelectors: userSelector ? userSelector.map(function (usId) { return usId.id; }) : undefined,
                };
                return [2 /*return*/, [tslib_1.__assign({}, commonFields, (this.accessFeeFormGroup.get('targetSegment').value === 'userSelectors' && endDate
                            ? { endDate: moment(endDate).format("YYYY-MM-DD") }
                            : {}), { tiers: this.formValue('tiers').map(function (tier, index) {
                                _this.validateTier(tier, index);
                                return {
                                    minValue: tier.minRides.value,
                                    amount: tier.tierAmount.value,
                                    strikeOutAmount: tier.strikeOutAmount.value
                                };
                            }) })]];
            });
        });
    };
    CreateAccessFeeComponent.prototype.validateTier = function (tier, index) {
        if (!tier.minRides || !Number.isInteger(tier.minRides.value) || tier.minRides.value <= 0) {
            this.errorMessage("minimum rides value is required for tier " + (index + 1));
            throw new Error("Minimum rides value is required/ should be non zero positive number for tier " + (index + 1));
        }
        if (!tier.tierAmount || (!Number.isInteger(tier.tierAmount.value) || tier.tierAmount.value < 0)) {
            this.errorMessage("Charged Fee is required and should be integer for tier  " + (index + 1));
            throw new Error("Charged Fee is required and should be non negative number for tier " + (index + 1));
        }
        if (tier.strikeOutAmount && (tier.strikeOutAmount.value || tier.strikeOutAmount.value == 0) &&
            (!Number.isInteger(tier.strikeOutAmount.value) || tier.strikeOutAmount.value < 0 || tier.strikeOutAmount.value <= tier.tierAmount.value)) {
            this.errorMessage("Striked Out amount should be positive number for tier " + (index + 1));
            throw new Error("Striked Out should be greater than charged fee for tier " + (index + 1));
        }
    };
    CreateAccessFeeComponent.prototype.addTier = function () {
        var defaultTierElement = {
            tierCondition: new FormControl(null),
            tierAmount: new FormControl(null),
            minRides: new FormControl(null),
            strikeOutAmount: new FormControl(null),
        };
        if (this.formValue('tiers')) {
            this.formValue('tiers').push(defaultTierElement);
        }
        else {
            this.accessFeeFormGroup.get('tiers').setValue([defaultTierElement]);
        }
    };
    CreateAccessFeeComponent.prototype.deleteTier = function (index) {
        this.formValue('tiers').splice(index, 1);
    };
    CreateAccessFeeComponent.prototype.validateModeAndGeoGroupIdForServices = function () {
        if (!this.formValue('services')) {
            return;
        }
        var distinctModes = new Set(this.formValue('services').map(function (service) { return service.mode; }));
        if (distinctModes.size > 1) {
            this.accessFeeFormGroup.get('services').setValue(null);
            this.alertMessage({
                title: "Error",
                message: "Please select services with same mode"
            });
            return;
        }
        var mode = distinctModes.values().next().value;
        return mode;
    };
    return CreateAccessFeeComponent;
}());
export { CreateAccessFeeComponent };
